import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import * as t from "./actionType";
import * as a from "./action";

import {
  // AP
  getWifiAccessPointList,
  getWifiAccessPointData,
  postWifiAccessPointCreate,
  putWifiAccessPointUpdate,
  deleteWifiAccessPointDelete,
  // PROFILE
  getWifiPortalGuestProfileList,
  getWifiPortalGuestProfileData,
  postWifiPortalGuestProfileCreate,
  putWifiPortalGuestProfileUpdate,
  deleteWifiPortalGuestProfileDelete,
  // SITE
  getWifiSiteLocationList,
  getWifiSiteLocationData,
  postWifiSiteLocationCreate,
  putWifiSiteLocationUpdate,
  deleteWifiSiteLocationDelete,
  postWifiSiteLocationUnifiTestConnection,
  postWifiSiteLocationUnifiSyncAps,
  postWifiSiteLocationComoTestConnection,
  // REG
  getWifiGuestRegistrationList,
  getWifiGuestRegistrationData,
  postWifiGuestRegistrationSearch,
  // ERRLOG
  getWifiPortalErrorLogList,
  getWifiPortalErrorLogData,
  postWifiPortalErrorLogSearch,
  // LINK
  getWifiSiteLocationToApList,
  postWifiSiteLocationToApCreate,
  deleteWifiSiteLocationToApDelete,
} from "../../helpers/fakebackend_helper";

// ---------- AP ----------
function* apListSaga() {
  try {
    const res = yield call(getWifiAccessPointList);
    yield put(a.wifiApListSuccess(res));
  } catch (e) {
    yield put(a.wifiApListFail(e));
  }
}
function* apDataSaga({ data }) {
  try {
    const res = yield call(getWifiAccessPointData, data);
    yield put(a.wifiApDataSuccess(res));
  } catch (e) {
    yield put(a.wifiApDataFail(e));
  }
}
function* apCreateSaga({ data }) {
  try {
    const res = yield call(postWifiAccessPointCreate, data);
    yield put(a.wifiApCreateSuccess(res));
  } catch (e) {
    yield put(a.wifiApCreateFail(e));
  }
}
function* apUpdateSaga({ data }) {
  try {
    const res = yield call(putWifiAccessPointUpdate, data);
    yield put(a.wifiApUpdateSuccess(res));
  } catch (e) {
    yield put(a.wifiApUpdateFail(e));
  }
}
function* apDeleteSaga({ data }) {
  try {
    const res = yield call(deleteWifiAccessPointDelete, data);
    yield put(a.wifiApDeleteSuccess(res));
  } catch (e) {
    yield put(a.wifiApDeleteFail(e));
  }
}

// ---------- PROFILE ----------
function* profileListSaga() {
  try {
    const res = yield call(getWifiPortalGuestProfileList);
    yield put(a.wifiProfileListSuccess(res));
  } catch (e) {
    yield put(a.wifiProfileListFail(e));
  }
}
function* profileDataSaga({ data }) {
  try {
    const res = yield call(getWifiPortalGuestProfileData, data);
    yield put(a.wifiProfileDataSuccess(res));
  } catch (e) {
    yield put(a.wifiProfileDataFail(e));
  }
}
function* profileCreateSaga({ data }) {
  try {
    const res = yield call(postWifiPortalGuestProfileCreate, data);
    yield put(a.wifiProfileCreateSuccess(res));
  } catch (e) {
    yield put(a.wifiProfileCreateFail(e));
  }
}
function* profileUpdateSaga({ data }) {
  try {
    const res = yield call(putWifiPortalGuestProfileUpdate, data);
    yield put(a.wifiProfileUpdateSuccess(res));
  } catch (e) {
    yield put(a.wifiProfileUpdateFail(e));
  }
}
function* profileDeleteSaga({ data }) {
  try {
    const res = yield call(deleteWifiPortalGuestProfileDelete, data);
    yield put(a.wifiProfileDeleteSuccess(res));
  } catch (e) {
    yield put(a.wifiProfileDeleteFail(e));
  }
}

// ---------- SITE ----------
function* siteListSaga() {
  try {
    const res = yield call(getWifiSiteLocationList);
    yield put(a.wifiSiteListSuccess(res));
  } catch (e) {
    yield put(a.wifiSiteListFail(e));
  }
}
function* siteDataSaga({ data }) {
  try {
    const res = yield call(getWifiSiteLocationData, data);
    yield put(a.wifiSiteDataSuccess(res));
  } catch (e) {
    yield put(a.wifiSiteDataFail(e));
  }
}
function* siteCreateSaga({ data }) {
  try {
    const res = yield call(postWifiSiteLocationCreate, data);
    yield put(a.wifiSiteCreateSuccess(res));
  } catch (e) {
    yield put(a.wifiSiteCreateFail(e));
  }
}
function* siteUpdateSaga({ data }) {
  try {
    const res = yield call(putWifiSiteLocationUpdate, data);
    yield put(a.wifiSiteUpdateSuccess(res));
  } catch (e) {
    yield put(a.wifiSiteUpdateFail(e));
  }
}
function* siteDeleteSaga({ data }) {
  try {
    const res = yield call(deleteWifiSiteLocationDelete, data);
    yield put(a.wifiSiteDeleteSuccess(res));
  } catch (e) {
    yield put(a.wifiSiteDeleteFail(e));
  }
}
function* siteUnifiTestSaga({ data }) {
  try {
    const res = yield call(postWifiSiteLocationUnifiTestConnection, data);
    yield put(a.wifiSiteUnifiTestSuccess(res));
  } catch (e) {
    yield put(a.wifiSiteUnifiTestFail(e));
  }
}
function* siteUnifiSyncSaga({ data }) {
  try {
    const res = yield call(postWifiSiteLocationUnifiSyncAps, data);
    yield put(a.wifiSiteUnifiSyncSuccess(res));
  } catch (e) {
    yield put(a.wifiSiteUnifiSyncFail(e));
  }
}
function* siteComoTestSaga({ data }) {
  try {
    const res = yield call(postWifiSiteLocationComoTestConnection, data);
    yield put(a.wifiSiteComoTestSuccess(res));
  } catch (e) {
    yield put(a.wifiSiteComoTestFail(e));
  }
}

// ---------- REG ----------
function* regListSaga() {
  try {
    const res = yield call(getWifiGuestRegistrationList);
    yield put(a.wifiRegListSuccess(res));
  } catch (e) {
    yield put(a.wifiRegListFail(e));
  }
}
function* regDataSaga({ data }) {
  try {
    const res = yield call(getWifiGuestRegistrationData, data);
    yield put(a.wifiRegDataSuccess(res));
  } catch (e) {
    yield put(a.wifiRegDataFail(e));
  }
}
function* regSearchSaga({ data }) {
  try {
    const res = yield call(postWifiGuestRegistrationSearch, data);
    yield put(a.wifiRegSearchSuccess(res));
  } catch (e) {
    yield put(a.wifiRegSearchFail(e));
  }
}

// ---------- ERRLOG ----------
function* errLogListSaga() {
  try {
    const res = yield call(getWifiPortalErrorLogList);
    yield put(a.wifiErrLogListSuccess(res));
  } catch (e) {
    yield put(a.wifiErrLogListFail(e));
  }
}
function* errLogDataSaga({ data }) {
  try {
    const res = yield call(getWifiPortalErrorLogData, data);
    yield put(a.wifiErrLogDataSuccess(res));
  } catch (e) {
    yield put(a.wifiErrLogDataFail(e));
  }
}
function* errLogSearchSaga({ data }) {
  try {
    const res = yield call(postWifiPortalErrorLogSearch, data);
    yield put(a.wifiErrLogSearchSuccess(res));
  } catch (e) {
    yield put(a.wifiErrLogSearchFail(e));
  }
}

// ---------- LINK ----------
function* linkListSaga({ data }) {
  try {
    const res = yield call(getWifiSiteLocationToApList, data);
    yield put(a.wifiLinkListSuccess(res));
  } catch (e) {
    yield put(a.wifiLinkListFail(e));
  }
}
function* linkCreateSaga({ data }) {
  try {
    const res = yield call(postWifiSiteLocationToApCreate, data);
    yield put(a.wifiLinkCreateSuccess(res));
  } catch (e) {
    yield put(a.wifiLinkCreateFail(e));
  }
}
function* linkDeleteSaga({ data }) {
  try {
    const res = yield call(deleteWifiSiteLocationToApDelete, data);
    yield put(a.wifiLinkDeleteSuccess(res));
  } catch (e) {
    yield put(a.wifiLinkDeleteFail(e));
  }
}

function* Wifi() {
  yield all([
    // AP
    takeEvery(t.WIFI_AP_LIST, apListSaga),
    takeEvery(t.WIFI_AP_DATA, apDataSaga),
    takeEvery(t.WIFI_AP_CREATE, apCreateSaga),
    takeEvery(t.WIFI_AP_UPDATE, apUpdateSaga),
    takeEvery(t.WIFI_AP_DELETE, apDeleteSaga),
    // PROFILE
    takeEvery(t.WIFI_PROFILE_LIST, profileListSaga),
    takeEvery(t.WIFI_PROFILE_DATA, profileDataSaga),
    takeEvery(t.WIFI_PROFILE_CREATE, profileCreateSaga),
    takeEvery(t.WIFI_PROFILE_UPDATE, profileUpdateSaga),
    takeEvery(t.WIFI_PROFILE_DELETE, profileDeleteSaga),
    // SITE
    takeEvery(t.WIFI_SITE_LIST, siteListSaga),
    takeEvery(t.WIFI_SITE_DATA, siteDataSaga),
    takeEvery(t.WIFI_SITE_CREATE, siteCreateSaga),
    takeEvery(t.WIFI_SITE_UPDATE, siteUpdateSaga),
    takeEvery(t.WIFI_SITE_DELETE, siteDeleteSaga),
    takeEvery(t.WIFI_SITE_UNIFI_TEST, siteUnifiTestSaga),
    takeEvery(t.WIFI_SITE_UNIFI_SYNC, siteUnifiSyncSaga),
    takeEvery(t.WIFI_SITE_COMO_TEST, siteComoTestSaga),
    // REG
    takeEvery(t.WIFI_REG_LIST, regListSaga),
    takeEvery(t.WIFI_REG_DATA, regDataSaga),
    takeEvery(t.WIFI_REG_SEARCH, regSearchSaga),
    // ERRLOG
    takeEvery(t.WIFI_ERRLOG_LIST, errLogListSaga),
    takeEvery(t.WIFI_ERRLOG_DATA, errLogDataSaga),
    takeEvery(t.WIFI_ERRLOG_SEARCH, errLogSearchSaga),
    // LINK
    takeEvery(t.WIFI_LINK_LIST, linkListSaga),
    takeEvery(t.WIFI_LINK_CREATE, linkCreateSaga),
    takeEvery(t.WIFI_LINK_DELETE, linkDeleteSaga),
  ]);
}

export default Wifi;
